import React from "react";
import { INavLink } from "src/components/HeaderNavBar/type";
import * as styles from "./FooterNavLink.module.scss";

interface FooterNavLinkProps {
  link: INavLink;
}

const FooterNavLink: React.FC<FooterNavLinkProps> = ({ link }) => {
  return (
    <a href={link.href} className={styles.navLink}>
      {link.title}
    </a>
  );
};

export default FooterNavLink;
